import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';

import { serviceDetailsNameRoot } from '../ServiceDetailsFormBody';
import { oxygenLitersPerMinFieldValidate } from './oxygenLitersPerMinFieldValidate';
import { FloatInput } from 'src/common/FloatInput';
import { FormFieldController } from 'src/common/FormField/FormFieldController';

export function OxygenLitersPerMinField() {
  const fieldName = `${serviceDetailsNameRoot}.oxygen_liters_per_min`;
  return (
    <FormFieldController
      name={fieldName}
      rules={{
        validate: oxygenLitersPerMinFieldValidate,
      }}
    >
      {({ field, fieldState }) => {
        const { onChange, ...remainingProps } = field;
        return (
          <DefaultFormFieldLayout
            label="Oxygen Amount (Liters per minute)"
            error={fieldState.error?.message?.toString()}
            inputId={fieldName}
          >
            <FloatInput
              {...remainingProps}
              onValueChange={(values: any) => {
                onChange(values.value);
              }}
              id={fieldName}
            />
          </DefaultFormFieldLayout>
        );
      }}
    </FormFieldController>
  );
}
